import { Tooltip } from '@mui/material';
import React from 'react';

export type SidebarItemType = {
	label: string;
	icon: React.ReactElement;
	route: string;
	slug: string;
	notificationIcon?: React.ReactElement;
};

export type SidebarItemProps = {
	item: SidebarItemType;
	isActive: boolean;
	sidebarIsExpanded: boolean;
	onClick: () => void;
	index: number;
};

const SidebarItem = ({
	item,
	isActive,
	sidebarIsExpanded,
	onClick,
	index,
}: SidebarItemProps) => {
	const content = (
		<button
			style={{
				animation: 'fadeInScale 0.150s ease forwards',
				animationDelay: `${index * 40}ms`,
				opacity: 0,
			}}
			key={item.label}
			onClick={onClick}
			className={`group text-left flex items-center gap-2 w-full rounded-xl py-2.5 ${
				isActive
					? 'bg-h-primary-95 text-h-primary font-medium'
					: 'text-h-neutral-40 hover:bg-h-neutral-94'
			}
                    ${sidebarIsExpanded ? 'px-4' : 'justify-center px-2'}
                    `}
		>
			<div className='relative'>
				{item.notificationIcon}
				{React.cloneElement(item.icon, {
					weight: isActive ? 'duotone' : 'light',
					size: 22,
					className: `min-w-[22px] max-w-[44px] group-hover:scale-110 transition-all ${sidebarIsExpanded ? '' : '-mr-2'}`,
				})}
			</div>
			<span
				className={`w-full overflow-hidden whitespace-nowrap ${sidebarIsExpanded ? 'max-w-full' : 'max-w-0 '}`}
			>
				{item.label}
			</span>
		</button>
	);

	if (sidebarIsExpanded) {
		return content;
	}

	return (
		<Tooltip
			title={item.label}
			placement='right'
			arrow
		>
			{content}
		</Tooltip>
	);
};

export default SidebarItem;
